import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-icon',
  standalone: false,
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss']

})
export class IconComponent implements IconInterface {
  @Input() name: string = '';
  @Input() type: string = 'solid';
  @Input() size: string = 'normal';
  @Input() iconStyle: string = '';
  @Input() status: string = '';
  @Input() inherit: boolean = false;
  isImage: boolean = false;

  private iconType = {
    solid: '#Filled_Icons',
    line: '#Line_Icons',
    doutone: ''
  };

  constructor() {
    if (this.name.includes('https')) {
      this.isImage = true;
    }
  }

  svgPath(type = this.type): string {
    const { name, iconType } = this;
    const typeID = iconType[type];

    return `${window.location.origin}/public/icons/${name}.svg${typeID}`;
  }
}

export interface IconInterface {
  name: string;
  type?: string;
  size?: string;
  iconStyle?: string;
  status?: string;
  inherit?: boolean;
}